// extracted by mini-css-extract-plugin
export default {"error":"style_error__0b4Fl","frame":"style_frame__Mb3fl"};